import { render } from "./Yingyong.vue?vue&type=template&id=2c2f7b4e"
import script from "./Yingyong.vue?vue&type=script&lang=js"
export * from "./Yingyong.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__